import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import Icon, { Icons } from '@shared/Icons/Icon';
import Panel from '../../../../../shared/Panel';
import Button from '../../../../../components/Button';
import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';
import { withTracking } from '../../../provider';

import {
  panel,
  modalContent,
  modalComponentWrapper,
  modalComponentTitle,
  cancelButton,
  applyButton,
  buttonsWrapper,
  desktopDropdown,
} from './styles.module.css';

const FilterSelectContainer = ({
  type,
  onClose,
  FilterComponent,
  modalTitle,
  isMobile,
  filterComponentProps,
  defaultFilters,
  injected: {
    tracking: { trackButtonClick },
  },
}) => {
  const [isSubmitActive, setIsSubmitActive] = useState(true);
  const [toUpdate, setToUpdate] = useState({});
  const { pushHistory } = useContext(DiscoveryContext);

  // Handler for react-onclickoutside
  FilterSelectContainer.handleClickOutside = (event) => {
    // Hack for not closing on Google Places autopicker
    const eventPath = event?.path ?? [];
    const pacEle = eventPath
      .map((n) => n.className)
      .filter(Boolean)
      .find((n) => n.indexOf('pac') !== -1);

    if (!isMobile && !pacEle) {
      onClose();
    }
  };

  const enableSubmit = () => {
    setIsSubmitActive(true);
  };

  const disableSubmit = () => {
    setIsSubmitActive(false);
  };

  const onClear = () => {
    trackButtonClick('filter_clear', {
      type,
    });

    pushHistory(defaultFilters);
    onClose();
  };

  const onCancel = () => {
    trackButtonClick('filter_cancel', {
      type,
      selectedValues: toUpdate,
    });
    onClose();
  };

  const onConfirm = () => {
    trackButtonClick('filter_apply', {
      type,
      selectedValues: toUpdate,
    });

    if (Object.entries(toUpdate).length) {
      pushHistory(toUpdate);
    }
    onClose();
  };

  const update = (obj) => {
    setToUpdate(obj);
  };

  const contents = (
    <div className={modalContent}>
      <div className={modalComponentWrapper}>
        <div className={modalComponentTitle}>
          <span>{modalTitle}</span>
          {isMobile && (
            <Icon icon={Icons.CROSS.THIN_BLACK} onClick={onCancel} />
          )}
        </div>
        <FilterComponent
          enableSubmit={enableSubmit}
          disableSubmit={disableSubmit}
          update={update}
          forceConfirm={onConfirm}
          isMobile={isMobile}
          {...filterComponentProps}
        />
      </div>

      <div className={buttonsWrapper}>
        <span className={cancelButton} onClick={onClear} onKeyPress={onClear}>
          Clear
        </span>

        {isSubmitActive ? (
          <Button primary onClick={onConfirm} className={applyButton}>
            Apply
          </Button>
        ) : (
          <Button disabled primary className={applyButton}>
            Apply
          </Button>
        )}
      </div>
    </div>
  );

  if (!__CLIENT__) {
    return null;
  }

  return isMobile ? (
    <Panel hideTitle className={`${panel} discovery`} onClose={onClose}>
      {contents}
    </Panel>
  ) : (
    <div className={`${desktopDropdown} discovery`}>{contents}</div>
  );
};

FilterSelectContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
};

const clickOutsideConfig = {
  handleClickOutside: () => FilterSelectContainer.handleClickOutside,
};

const ClickOutsideComponent = onClickOutside(
  FilterSelectContainer,
  clickOutsideConfig,
);

const ClickOutsideComponentWithProps = (props) => (
  <ClickOutsideComponent eventTypes="click" {...props} />
);

export default withTracking('filter')(ClickOutsideComponentWithProps);
